import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Loader from "./subComponents/loader"
import ErrorModal from "./subComponents/errorModal";
import moment from "moment-timezone";
import BrokenImageIcon from "../assets/brokenImage.png";
import UploadViewStyle from "../styles/uploadViewStyle";
import { MIME_TYPE_COLLECTION as MimeTypeCollection } from '../constants/patientChart.constant';
import { PDFViewer } from './PDFViewer';

const DefaultFileType = 'png';

class UploadView extends React.Component {

    componentDidMount() {
        let { GetUploadtInfo, match, GetPatientInfo } = this.props;
        let PatientId = match && match.params && match.params.patientId;
        let OrderId = match && match.params && match.params.orderId;
        let QuestionId = match && match.params && match.params.questionId;
        GetUploadtInfo && GetUploadtInfo({ OrderId, QuestionId });
        GetPatientInfo && GetPatientInfo({ OrderId, UserId: PatientId });
    }

    loadImage = ({ id = '', url = '' }) => {
        const type = (() => {
            try {
                // eslint-disable-next-line no-unused-vars
                const [_, type] = id.split('.');
                return type;
            } catch(e) {
                return DefaultFileType;
            }
        })();

        const mimeType = MimeTypeCollection.has(type)
            ? MimeTypeCollection.get(type)
            : MimeTypeCollection.get(DefaultFileType);

        return {
            base64: `data:${mimeType};base64,${url}`,
            type,
        };
    }


    getDateFormat = (Date) => {
        let timeZone = moment.tz.guess();
        return moment.tz(Date, timeZone).format('L');
    }

    expandImage = (subIndex, indexMain) => {
        let { uploadedDocs, SetUploadedDocs } = this.props;
        let uploadedDocsTemp = [...uploadedDocs];
        uploadedDocsTemp.length !== 0 && uploadedDocsTemp.forEach(element => {
            element.DocumentUploadImages.length !== 0 && element.DocumentUploadImages.forEach(images => {
                images.Expanded = false;
            })
        });
        uploadedDocsTemp[indexMain]['DocumentUploadImages'][subIndex]['Expanded'] = true;
        SetUploadedDocs && SetUploadedDocs(uploadedDocsTemp);
    }

    collapseImage = (subIndex, indexMain) => {
        let { uploadedDocs, SetUploadedDocs } = this.props;
        let uploadedDocsTemp = [...uploadedDocs];
        uploadedDocsTemp.length !== 0 && uploadedDocsTemp.forEach(element => {
            element.DocumentUploadImages.length !== 0 && element.DocumentUploadImages.forEach(images => {
                images.Expanded = false;
            })
        });
        SetUploadedDocs && SetUploadedDocs(uploadedDocsTemp);
    } 

    getImageArray = () => {
        let imagesMainUI = [];
        const { classes, uploadedDocs } = this.props;
        uploadedDocs.length !== 0 && uploadedDocs.forEach((imageArray, indexMain) => {
            imagesMainUI.push(<div className={classes.imageWrapper}>
                <div className={classes.imageInfoWrapper}>
                    <div className={classes.dateText}>{imageArray.OrderDate}</div>
                    <div className={classes.questionText} >{imageArray.QuestionText}</div>
                </div>
                {this.getImages(imageArray, indexMain)}
            </div>);
        })
        return imagesMainUI;
    }

    getImages = (imageArray, indexMain) => {
        let imagesSubUI = [];
        const { classes } = this.props;
        imageArray.DocumentUploadImages.length !== 0 && imageArray.DocumentUploadImages.forEach((image, subIndex) => {
            const imageFile = this.loadImage({ id: image.ImageId, url: image.ImageBase64Data });

            imagesSubUI.push(<div className="flex flex-column p-6">
                <div className={`flex flex-column ${classes.imageshowWrapper}`}>
                    <label className={`${classes.imageLabel} m-b-3`}> {image.AnswerText || ""}</label>
                    {
                        image.ImageBase64Data
                        ?   (
                            !(image.Expanded)
                            ? (
                                <div className={classes.imageDisplayWrapper}>
                                    {
                                        imageFile.type === 'pdf'
                                        ? <PDFViewer file={imageFile.base64} style={{ minWidth: 760 }} />
                                        : (
                                            <embed
                                                className={classes.imageDisplay}
                                                id={indexMain+'-'+subIndex+'-image'}
                                                src={imageFile.base64}
                                                onClick={() => this.expandImage(subIndex, indexMain)}
                                            />
                                        )
                                    }
                                    
                                </div>
                            )
                            : (
                                <div className={`flex ${classes.imageshowWrapper}`}>
                                    <embed
                                        className={classes.imageLargeDisplay}
                                        id={indexMain+'-'+subIndex+'-large-image'}
                                        src={imageFile.base64}
                                        onClick={() => this.collapseImage(subIndex, indexMain)}
                                    />
                                </div>
                            )
                        )
                        :   (
                            <div className={classes.imageDisplayWrapper}>
                                <div className={classes.imageDefaultWrapper}>
                                    <img className={classes.imageDefault} src={BrokenImageIcon} alt="" />
                                    <label className={classes.imageDefaultLabel}>Unable to load images</label>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>)
        })
        return imagesSubUI;
    }

    render() {
        const {
            classes,
            errorModalOpen,
            loading,
            ToggleErrorModal,
            selectedPatientInfo,
        } = this.props;
        return (<div className={classes.wrapper} data-view="upload-view-component-wrapper">
                <div className={classes.contentWrapper} data-view="patientuploadinfo">
                    <div className={classes.patientInfoWrapper}>
                        <div className={classes.simpleHeadingText}>Uploaded Files</div>
                        <div className={classes.patientNameText} >{selectedPatientInfo.FirstName} {selectedPatientInfo.LastName}</div>
                        <div className={classes.subheadingText} >(click image to enlarge or reduce)</div>
                    </div>
                    <div className={classes.borderSection}></div>
                    <div className={classes.scrollSection}>
                        {this.getImageArray()}
                    </div>
                </div>
                <ErrorModal modalOpen={errorModalOpen} closeModal={() => ToggleErrorModal(false)} />
                {loading ? <Loader /> : null}
            </div>
        )
    }
}

export default withStyles(UploadViewStyle)(UploadView);
